var map = {
	"./info-sharing-center-de.html": 939,
	"./info-sharing-center-en.html": 940,
	"./info-sharing-center-es.html": 941,
	"./info-sharing-center-fr.html": 942,
	"./info-sharing-center-ja.html": 943,
	"./info-sharing-center-pt.html": 944,
	"./info-sharing-center-zh.html": 945
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 938;


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-center ^\.\/info\-sharing\-center\-.*\.html$
// module id = 938
// module chunks = 0